module.exports = {"120104001":"长虹街道","120104002":"鼓楼街道","120104003":"兴南街道","120104004":"广开街道","120104005":"万兴街道","120104006":"学府街道","120104007":"向阳路街道","120104008":"嘉陵道街道","120104009":"王顶堤街道","120104010":"水上公园街道","120104011":"体育中心街道","120104012":"华苑街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120104.json
// module id = 128
// module chunks = 0